// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  background: rgba(255, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 3px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  touch-action: manipulation;
}

.delete-btn:hover {
  background: rgba(255, 0, 0, 0.9);
}

.thumbnail-container {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none; /* Prevent browser's default touch handling */
}

/* Make sure the drag handle doesn't block clicks */
.drag-handle {
  position: relative;
  width: 100%;
  height: 100%;
  touch-action: none; /* Disable default touch behaviors like scrolling */
  cursor: grab;
}

/* Styles for mobile optimization */
@media (max-width: 768px) {
  .thumbnail-container {
    width: 120px !important;
    height: 120px !important;
  }
  
  .delete-btn {
    width: 30px;
    height: 30px;
    right: 3px;
    top: 3px;
  }
  
  .thumbnails-wrapper {
    padding: 10px;
  }
  
  .thumbnails-container {
    gap: 8px;
  }
}

/* Style for active dragging state */
.thumbnail-container[data-dragging="true"] {
  z-index: 999;
  opacity: 0.8;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

/* Style for the thumbnail container wrapper */
.thumbnails-wrapper {
  border: 2px dashed #333;
  border-radius: 8px;
  padding: 10px;
  background-color: #140714;
  position: relative;
}

/* Add drag indicator label */
.thumbnails-wrapper::before {
  content: "Drag to rearrange";
  position: absolute;
  top: -10px;
  left: 20px;
  background-color: #333;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
}

/* Center thumbnails in the container */
.thumbnails-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThumbnailRearrange.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,mDAAmD;EACvE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,YAAY;EACZ,uCAAuC;AACzC;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb","sourcesContent":[".delete-btn {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  background: rgba(255, 0, 0, 0.7);\n  color: white;\n  border: none;\n  border-radius: 3px;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  touch-action: manipulation;\n}\n\n.delete-btn:hover {\n  background: rgba(255, 0, 0, 0.9);\n}\n\n.thumbnail-container {\n  position: relative;\n  user-select: none;\n  touch-action: none; /* Prevent browser's default touch handling */\n}\n\n/* Make sure the drag handle doesn't block clicks */\n.drag-handle {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  touch-action: none; /* Disable default touch behaviors like scrolling */\n  cursor: grab;\n}\n\n/* Styles for mobile optimization */\n@media (max-width: 768px) {\n  .thumbnail-container {\n    width: 120px !important;\n    height: 120px !important;\n  }\n  \n  .delete-btn {\n    width: 30px;\n    height: 30px;\n    right: 3px;\n    top: 3px;\n  }\n  \n  .thumbnails-wrapper {\n    padding: 10px;\n  }\n  \n  .thumbnails-container {\n    gap: 8px;\n  }\n}\n\n/* Style for active dragging state */\n.thumbnail-container[data-dragging=\"true\"] {\n  z-index: 999;\n  opacity: 0.8;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n/* Style for the thumbnail container wrapper */\n.thumbnails-wrapper {\n  border: 2px dashed #333;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #140714;\n  position: relative;\n}\n\n/* Add drag indicator label */\n.thumbnails-wrapper::before {\n  content: \"Drag to rearrange\";\n  position: absolute;\n  top: -10px;\n  left: 20px;\n  background-color: #333;\n  padding: 0 10px;\n  font-size: 12px;\n  color: #fff;\n}\n\n/* Center thumbnails in the container */\n.thumbnails-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
